/**
 * @generated SignedSource<<43a476abc9bebc9de2f7e93aba71d561>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type urlsFragment_user$data = {
  readonly username: string;
  readonly " $fragmentType": "urlsFragment_user";
};
export type urlsFragment_user$key = {
  readonly " $data"?: urlsFragment_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"urlsFragment_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "urlsFragment_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    }
  ],
  "type": "UserType",
  "abstractKey": null
};

(node as any).hash = "d52353c0dbc64827e5a6f73f8bd15921";

export default node;
